const createUID = (len?: number) => {
    const buf: unknown[] = []
    const chars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charLen = chars.length
    const length = len || 10

    for (let i = 0; i < length; i++) {
        buf[i] = chars.charAt(Math.floor(Math.random() * charLen))
    }
    return buf.join('')
}

export default createUID
